
import Vue, { PropType } from 'vue';
import BaseProgress from '@/components/base/BaseProgress.vue';

export type BatchProgressRowState = 'pending' | 'processing' | 'initialized' | 'failed';

const BATCH_PROGRESS_ROW_STATE_LABEL: Record<BatchProgressRowState, string> = {
	pending: 'Pending',
	processing: 'Processing',
	initialized: 'Started',
	failed: 'Failed',
};

export interface BatchProgressRow {
	index: number
	label: string
	state: BatchProgressRowState
}

export default Vue.extend({
	name: 'RunnitBatchProcessingProgressCard',
	components: { BaseProgress },
	props: {
		rows: { type: Array as PropType<BatchProgressRow[]>, required: true },
		/** 0–1 based on terminal outcomes */
		progressFraction: { type: Number, default: 0 },
	},
	computed: {
		progressPercent (): number {
			return Math.round(Math.min(1, Math.max(0, this.progressFraction)) * 100);
		},
	},
	methods: {
		stateLabel (s: BatchProgressRowState): string {
			return BATCH_PROGRESS_ROW_STATE_LABEL[s];
		},
		stateColor (s: BatchProgressRowState) {
			if (s === 'initialized') return 'var(--green-400)';
			if (s === 'failed') return 'var(--red-400)';
			if (s === 'processing') return 'var(--grey-400)';
			return 'var(--grey-600)';
		},
		stateIcon (s: BatchProgressRowState) {
			if (s === 'initialized') return 'mdi-check';
			if (s === 'failed') return 'mdi-close-circle';
			if (s === 'processing') return 'mdi-progress-clock';
			return 'mdi-circle-outline';
		},
	},
});
